const title = 'Apply'
export default [
  {
    path: 'apply-document',
    name: 'apply-document',
    component: () => import('@/views/pages/apply-document/ApplyDocument.vue'),
    meta: {
      pageTitle: `${title} Documents`,
      breadcrumb: [
        {
          text: `${title} Documents`,
          active: true,
        },
      ],
      resource: 'ApplyDocument',
      isOtm: false,
      isInno: false,
      isMe: true,
    },
  },
  {
    path: 'apply-document/:id',
    name: 'apply-document-view',
    component: () => import('@/views/pages/apply-document/View.vue'),
    meta: {
      pageTitle: title,
      breadcrumb: [
        {
          to: { name: 'apply-document' },
          text: `${title} Documents`,
          active: false,
        },
        {
          text: `${title} Document`,
          active: true,
        },
      ],
      resource: 'ApplyDocument',
      isOtm: false,
      isInno: false,
    },
  },
]
